import { Feature } from 'ol';
import Map from 'ol/Map';
import { isDrawGeometryType } from './isDrawGeometryType';
import { getCenter } from 'ol/extent';
import { shapeToFeature } from './tranformations/shapeToFeature';
import { GeoJson } from '@ais-ui/api-spec/shapes';

export const zoomToFeatureExtent = (
  feature: Feature,
  map: Map,
  padding = [50, 50, 50, 50]
) => {
  const geometry = feature.getGeometry();

  if (geometry) {
    const extent = geometry.getExtent();

    if (isDrawGeometryType(geometry.getType()) && extent) {
      const view = map.getView();
      if (geometry.getType() === 'Point') {
        const center = getCenter(extent);
        view.setCenter(center);
        view.setZoom(14);
      } else {
        view.fit(extent, {
          padding: padding,
          duration: 500,
        });
      }
    }
  }
};

export const zoomToShapeExtent = (shape: GeoJson, map: Map) => {
  const feature = shapeToFeature(shape);

  if (!feature) {
    return;
  }

  return zoomToFeatureExtent(feature, map);
};
